require('./contactCenterValidationCards.scss');

// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
const { Component } = require('react');
const { connect } = require('react-redux');
const { isEmpty } = require('lodash');

//@core
const { FormattedText, formatText } = require('core/i18n').i18n;

// @helpers
const { getEmail } = require('utilities/personalDataHelper');
const BrowserUtils = require('utilities/browserUtils');
const { base64ToBlob } = require('utilities/APIRequestHelper');
const { validRevolvingCardType } = require('utilities/APIParsingHelper');

// @ Utils
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
const { openPDFViewer } = require('utilities/contactCenter/pdfViewer');

// @actions
const preContractualMailActions = require('actions/contactCenter/preContractualMailInfo/preContractualMailInfo');
const profileActions = require('actions/profile');
const revolvingActions = require('actions/cardRevolvingDocuments');

// @ components
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const PreContractualMailInfo = require('components/contactCenter/preContractualMailInfo/preContractualMailInfo');

// @commons
const { OKButton } = require('components/commons/OKButton/OKButton');
const { EmptyState } = require('commonsComponents/emptyState');

// @ Constants
const { EMPTY_STATE_NOCARD_BANKING } = require('constants/index');
const { DIAMOND_PACK_PRODUCT_NAME, PREMIUM_PACK_PRODUCT_NAME } = require('constants/cardsPrecontractualMailInfo');
const { REVOLVING_INE } = require('constants/flagBasedFeatures');

class ContactCenterValidationCards extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isValidForCC: this.checkInformation()
        }
    }

    componentDidMount() {
        const { showIneAndRevolving } = this.props;
        if (showIneAndRevolving) {
            const {
                handleAgreementCheckboxChange,
                requestRevolvingInsuranceUrl,
                resetPrecontractualMail,
                resetRevolvingProcess,
                precontractualMailProductInfo
            } = this.props;

            const fakeCheckboxEvent = {
                target: {
                    checked: false
                }
            }
            handleAgreementCheckboxChange(fakeCheckboxEvent);
            resetPrecontractualMail();
            resetRevolvingProcess();
            isPrintOfficeMode() && requestRevolvingInsuranceUrl(precontractualMailProductInfo);
            this.requestDocuments(true, true);
            this.validateTermsAndCondsText();
        }
    }

    componentWillUnmount() {
        const { showIneAndRevolving } = this.props;
        if (showIneAndRevolving) {
            const { resetRevolvingProcess, resetPrecontractualMail } = this.props;
            resetPrecontractualMail();
            resetRevolvingProcess();
        }
    }

    validateTermsAndCondsText = () => {
        const { precontractualMailProductInfo, setTermsAndCondsText, showRevolvingDocument } = this.props;
        let textTermsAndConds = {
            inne: this.getPoeKey('inneCheckboxText')
        };
        if (showRevolvingDocument) {
            const {
                productName,
                producto,
                standard,
                subproducto,
            } = precontractualMailProductInfo;

            const isPremiumOrDiamondCard = productName === PREMIUM_PACK_PRODUCT_NAME || (productName === DIAMOND_PACK_PRODUCT_NAME &&
                (producto !== '501' || subproducto !== '004' || (standard !== '0000001' && standard !== '0000002')) // This case is for diamond infinite
            );

            const poEditorKey = isPremiumOrDiamondCard ? 'documentCheckboxTextPremiumDiamond' : 'documentCheckboxText';
            textTermsAndConds['revolving'] = this.getPoeKey(poEditorKey);
        }

        setTermsAndCondsText(textTermsAndConds);
    }

    handleSendPreContractualInfo = (sendMailParams) => {
        const { sendPrecontractualDocumentMail, showRevolvingDocument, isContractingProcess, immPdfRevolvingPersistent, immFlagBasedFeatures, precontractualMailProductInfo } = this.props;
        const temporaryDocumentId = immPdfRevolvingPersistent.get('temporaryDocumentId');
        const { standar, subType, type } = sendMailParams;
        const revolvingDocumentFeatureFlag = immFlagBasedFeatures.get('revolving_v2_ine');

        const params = {
            product: {
                standard: standar,
                subtype: subType,
                type
            },
            contactCenter: true,
            sendInsuranceDocument: isContractingProcess,
            sendRelevantRevolvingDocument: revolvingDocumentFeatureFlag && revolvingDocumentFeatureFlag && validRevolvingCardType(precontractualMailProductInfo.producto, precontractualMailProductInfo.subproducto)
                ? !revolvingDocumentFeatureFlag
                : showRevolvingDocument,
            temporaryDocumentId
        };
        sendPrecontractualDocumentMail(params);
    }

    getPoeKey = (key) => {
        return `revolvingProcessDocuments-revolvingProcessDocuments_${key}`;
    }

    checkInformation = () => {
        const { immHireInformation, immHiringProductInformation, immFlagBasedFeatures, isContractingProcess } = this.props
        const gestorCrossEnabled = immFlagBasedFeatures.get('web-gc-enabled');
        const information = gestorCrossEnabled ? immHiringProductInformation.get('cmsResponse') : immHireInformation.get('information');
        return !isContractingProcess || !!information
    }

    handleOpenDocument = (evt, base64string, customId) => {
        evt.preventDefault();

        if (base64string && !isEmpty(base64string)) {
            const newPdfBlob = new Blob([base64ToBlob(base64string)], { type: "application/pdf" });

            if (BrowserUtils.browserIsIE()) {
                window.navigator.msSaveOrOpenBlob(newPdfBlob);
            } else {
                openPDFViewer(base64ToBlob(base64string), customId);
            }
        }
    }

    requestDocuments = (inneError = false, documentError = false) => {
        const {
            requestRevolvingDocument,
            precontractualMailProductInfo,
            showRevolvingDocument,
            amount
        } = this.props;
        if (inneError) {
            requestRevolvingDocument('inne', precontractualMailProductInfo, showRevolvingDocument, amount);
            if (documentError && showRevolvingDocument) {
                requestRevolvingDocument('document', precontractualMailProductInfo);
            }
        }
    }

    buildCCHireCardProcess = () => {
        const {
            agreementErrorMsg,
            agreementLabel,
            contractName,
            handleAgreementCheckboxChange,
            immFlagBasedFeatures,
            immPreContractualMail,
            immProfile,
            immStep,
            requestProfile,
            sendMailParams,
            sendPreContractualMail,
            showIneAndRevolving,
            showRevolvingDocument,
            immPdfRevolving
        } = this.props;

        const inneIsLoading = immPdfRevolving.get('inneIsFetching');
        const documentIsLoading = immPdfRevolving.get('documentIsFetching');
        const inneErrorContent = immPdfRevolving.get('inneError');
        const documentErrorContent = immPdfRevolving.get('documentError');
        const clientEmail = getEmail(immProfile)
        const profileError = immProfile.get('error');
        const agreementChecked = immStep.get('agreementChecked');
        const agreementErrorVisible = immStep.get('agreementIsDirty') && !immStep.get('agreementChecked');
        const hasBeenEmailSent = immPreContractualMail.get('mailSent');
        let agreementLabelCheckbox = agreementLabel;
        let legalTextAreaLabel = '';

        if (showIneAndRevolving) {
            let splitMessage = formatText(this.getPoeKey(`documentCheckboxTextCC${immFlagBasedFeatures.get(REVOLVING_INE) || !showRevolvingDocument ? '2' : '1'}`)).split('%s');
            const revolvingType = immFlagBasedFeatures.get(REVOLVING_INE) || !showRevolvingDocument ? '2' : '1'

            const injectedLinks = [
                { type: 'inne', key: this.getPoeKey('innePdfName2') },
                { type: 'document', key: this.getPoeKey('documentPdfName') }
            ];
            agreementLabelCheckbox = splitMessage.map((message, index, array) => {

                if ((index !== array.length - 1 && revolvingType === '1') || (revolvingType === '2' && index === 0)) {
                    const documentName = injectedLinks[index] ? (formatText(injectedLinks[index].key)) : '';
                    const type = injectedLinks[index].type;
                    const base64string = immPdfRevolving.getIn([`${type}PDF`, 'base64string']);
                    const replacement = injectedLinks[index] ? (base64string && !isEmpty(base64string) ? (
                        <OKButton
                            onClick={evt => this.handleOpenDocument(evt, base64string, type)}
                            modifier="link-emphasize"
                            autoHeight
                            loading={false}
                        >
                            {documentName}
                        </OKButton>
                    ) : <strong>{documentName}</strong>) : '';

                    return (
                        <span key={index}>
                            {message}
                            {replacement}
                        </span>
                    );
                } else if (index === 1 && revolvingType === '2') {
                    return (
                        <span key={index}>
                            {message}
                            <FormattedText value={'revolvingProcessDocuments-provisionContract'} />
                        </span>
                    )
                }
                return message;
            });

            legalTextAreaLabel = `${formatText(this.getPoeKey('readInneInformation'))} ${!immFlagBasedFeatures.get(REVOLVING_INE) && showRevolvingDocument ? formatText(this.getPoeKey('readRelevantInformation')) : ''}`
        }

        return (
            <section className="contac-center-cards-validation__legal-confirmation-section">
                {inneErrorContent || documentErrorContent ?
                    this.buildErrorComponent(inneErrorContent, documentErrorContent)
                    : null
                }
                <PreContractualMailInfo
                    contractName={contractName}
                    disableSendButton={inneIsLoading || documentIsLoading || !!inneErrorContent || !!documentErrorContent}
                    loadingSendButton={inneIsLoading || documentIsLoading}
                    email={clientEmail}
                    preContractualMail={immPreContractualMail}
                    profileError={profileError}
                    requestProfile={requestProfile}
                    sendEmail={showIneAndRevolving ? this.handleSendPreContractualInfo : sendPreContractualMail}
                    sendMailParams={sendMailParams}
                    legalTextAreaLabel={legalTextAreaLabel}
                />
                <div className="contac-center-cards-validation__checkbox-container">
                    <OKCheckbox
                        idName="hireCardDiamondPackAgreementCheckbox"
                        disabled={!hasBeenEmailSent}
                        errorState={agreementErrorVisible}
                        errorMessage={agreementErrorMsg}
                        label={agreementLabelCheckbox}
                        onChange={handleAgreementCheckboxChange}
                        value={agreementChecked}
                    />
                </div>
            </section>
        );
    }

    buildErrorComponent = (inneErrorContent, documentErrorContent) => {
        const retryButton = (
            <OKButton
                modifier="secondary"
                onClick={() => { this.requestDocuments(inneErrorContent, documentErrorContent); }}>
                <FormattedText value={this.getPoeKey('retryButton')} />
            </OKButton>
        );

        return (
            <div>
                <EmptyState
                    button={retryButton}
                    primaryText={formatText(this.getPoeKey('errorMessage'))}
                    iconType={EMPTY_STATE_NOCARD_BANKING}
                    withMargin={true}
                />
                <div className="revolving-error__content-err">
                    <FormattedText value={this.getPoeKey('pdfErrorMessage')} />
                </div>
            </div>
        );
    }

    notInformation = () => {
        const emptyStateTitle = formatText('hireInformationComponent-emptyStateTitle');
        const emptyStateText = formatText('hireInformationComponent-emptyStateText');

        return <EmptyState title={emptyStateTitle} primaryText={emptyStateText} iconType="nointernet-banking" />;
    }

    render() {
        const { isValidForCC } = this.state;
        return isValidForCC ? this.buildCCHireCardProcess() : this.notInformation();
    }
}

ContactCenterValidationCards.propTypes = {
    amount: PropTypes.any,
    agreementErrorMsg: PropTypes.string,
    agreementLabel: PropTypes.string,
    contractName: PropTypes.string,
    handleAgreementCheckboxChange: PropTypes.func,
    immFlagBasedFeatures: PropTypes.object,
    immHireInformation: PropTypes.object,
    immHiringProductInformation: PropTypes.object,
    immPreContractualMail: PropTypes.object,
    immProfile: PropTypes.object,
    immStep: PropTypes.object,
    immPdfRevolving: PropTypes.object,
    immPdfRevolvingPersistent: PropTypes.object,
    isContractingProcess: PropTypes.bool,
    precontractualMailProductInfo: PropTypes.object,
    requestProfile: PropTypes.func,
    requestRevolvingDocument: PropTypes.func,
    requestRevolvingInsuranceUrl: PropTypes.func,
    resetPrecontractualMail: PropTypes.func,
    resetRevolvingProcess: PropTypes.func,
    sendMailParams: PropTypes.object,
    sendPreContractualMail: PropTypes.func,
    sendPrecontractualDocumentMail: PropTypes.func,
    setTermsAndCondsText: PropTypes.func,
    showIneAndRevolving: PropTypes.bool,
    showRevolvingDocument: PropTypes.bool,
};

module.exports = connect(
    state => ({
        immFlagBasedFeatures: state.flagBasedFeatures,
        immHireInformation: state.hireInformation,
        immHiringProductInformation: state.hiringProductInformation,
        immPreContractualMail: state.preContractualMail,
        immProfile: state.profile,
        immPdfRevolving: state.revolvingDocumentsPdfs,
        immPdfRevolvingPersistent: state.revolvingPersistentData
    }),
    {
        requestProfile: profileActions.requestProfile,
        requestRevolvingDocument: revolvingActions.requestRevolvingDocument,
        requestRevolvingInsuranceUrl: revolvingActions.requestRevolvingInsuranceUrl,
        resetPrecontractualMail: preContractualMailActions.resetPrecontractualMail,
        resetRevolvingProcess: revolvingActions.resetRevolvingProcess,
        sendPreContractualMail: preContractualMailActions.sendPreContractualMail,
        sendPrecontractualDocumentMail: revolvingActions.sendPrecontractualDocumentMail,
        setTermsAndCondsText: revolvingActions.setTermsAndCondsText,
    }
)(ContactCenterValidationCards);

module.exports.ContactCenterValidationCards = ContactCenterValidationCards;
